import flatten from "lodash-es/flatten";
import { Reducer } from "redux";

import {
    ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE,
    ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST,
    ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS,
    ArticleExperiencePhotoFetchFailureAction,
    ArticleExperiencePhotoFetchRequestAction,
    ArticleExperiencePhotoFetchSuccessAction,
} from "@/mk2/apps/wiki/containers/ArticleExperiencePhoto/ArticleExperiencePhoto.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";
import { WikiArticleEntity, WikiArticleSchema } from "@/mk2/schemas";
import { getDenormalizedEntity } from "@/mk2/selectors";

export interface ArticleExperiencePhotosState {
    loadingState: LoadingState;
    errorMessage: string;
    articleId: number | null;
    articleExperienceId: number | null;
    articleExperiencePhotoIds: number[];
}

export const initialArticleExperiencePhotosState: ArticleExperiencePhotosState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    articleId: null,
    articleExperienceId: null,
    articleExperiencePhotoIds: [],
};

export interface ArticlesExperiencePhotosState {
    [key: string]: ArticleExperiencePhotosState;
}

export const initialArticlesExperiencePhotosState: ArticlesExperiencePhotosState = {};

declare type ArticlesExperiencePhotosReducerAction =
    | ArticleExperiencePhotoFetchRequestAction
    | ArticleExperiencePhotoFetchSuccessAction
    | ArticleExperiencePhotoFetchFailureAction;

export const articlesExperiencePhotosReducer: Reducer<
    ArticlesExperiencePhotosState,
    ArticlesExperiencePhotosReducerAction
> = (state = initialArticlesExperiencePhotosState, action) => {
    switch (action.type) {
        case ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST:
        case ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            const articleState = state[key] || initialArticleExperiencePhotosState;
            return tupdate(state, {
                [key]: tupdate(articleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(articleState.errorMessage, action),
                }),
            });
        }

        case ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS: {
            const key = `${action.categorySlug}/${action.articleSlug}`;
            const articleState = state[key] || initialArticleExperiencePhotosState;
            return tupdate(state, {
                [key]: tupdate(articleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                    articleId: action.response.result.article,
                    articleExperienceId: action.experienceId,
                    articleExperiencePhotoIds: flatten(
                        getDenormalizedEntity<WikiArticleEntity>(
                            action.response,
                            WikiArticleSchema,
                            action.response.result.article,
                        ).experiences.map((exp) => exp.photos),
                    ).map((photo) => photo.id),
                }),
            });
        }

        default:
            return state;
    }
};
